export const preventOrphanWords = (text: string): string => {
  const words = text.split(' ')
  if (words.length > 3) {
    // Move last three words together using non-breaking spaces
    const lastThree = words.splice(-3, 3)
    words.push(lastThree.join('&nbsp;'))
  }
  return words.join(' ')
}

/**
 * Alternative implementation that moves the last three words together using non-breaking spaces
 */
// export const preventOrphanWords = (text: string): string => {
//   const words = text.split(' ')
//   if (words.length > 3) {
//     words[words.length - 2] += `&nbsp;${words.pop()}`
//   }
//   return words.join(' ')
// }
